import type { Ref } from 'vue'

interface UseIdentityAnalytics {
  /** The value AY gets as its HEM provider dimension, once identity resolves. */
  hemProvider: Ref<string | undefined>
}

export function useIdentityAnalytics(): UseIdentityAnalytics {
  return {
    hemProvider: useState<string | undefined>('hemProvider', () => undefined),
  }
}
